import { handleActions } from 'redux-actions'
import * as actions from '../actions'

const defaultValue = []

export default handleActions(
  {
    [actions.addImageTo3dModel](state, action) {
      return [...state, action.payload]
    },
    [actions.addAllPages3dToModel](state, action) {
      let pages = action.payload
      pages = pages.filter((item) => !state.some((page) => page.id === item.id))

      const newState = [...state]
      pages.forEach((page) => newState.push(page))

      return newState
    },
    [actions.updateImages3dModel](state, action) {
      return [...action.payload]
    },
    [actions.deleteImageFrom3dModel](state, action) {
      const index = action.payload
      return [...state.slice(0, index), ...state.slice(index + 1)]
    },
    [actions.close3dModelDialog](state, action) {
      return defaultValue
    },
    [actions.resetState](state, action) {
      return defaultValue
    },
  },
  defaultValue
)
